<template>
  <v-overlay v-model="show" class="align-center justify-center">
    <v-alert
      v-if="show"
      data-cy="errorAlert"
      type="error"
      max-width="50vw"
      class="rounded-xl bg-white"
      variant="outlined"
      icon="mdi-alert"
      closable>
      <template #close>
        <v-btn
          icon="mdi-close-circle"
          variant="text"
          size="small"
          style="padding-top: 3px"
          @click="close" />
      </template>
      <span v-if="resolvedAllowHtml" v-html="resolvedMessage" />
      <span v-else>{{ resolvedMessage }}</span>
    </v-alert>
  </v-overlay>
</template>

<script>
import { useErrorStore } from "@/stores/ErrorStore";

export default {
  name: "ErrorDialog",
  props: {
    message: { type: String, default: undefined },
    allowHtml: { type: Boolean, default: true },
  },
  emits: ["dismissError"],
  setup() {
    return { errorStore: useErrorStore() };
  },
  computed: {
    resolvedMessage() {
      return this.message !== undefined
        ? this.message
        : this.errorStore.message;
    },
    resolvedAllowHtml() {
      return this.message !== undefined
        ? this.allowHtml
        : this.errorStore.allowHtml;
    },
    show: {
      get() {
        return !!this.resolvedMessage;
      },
      set(value) {
        if (!value) {
          this.close();
        }
      },
    },
  },
  methods: {
    close() {
      if (this.message !== undefined) {
        this.$emit("dismissError");
      } else {
        this.errorStore.dismissError();
      }
    },
  },
};
</script>
